module.exports = __webpack_public_path__ + "static/flags/IL-4e00214508a91eb7bfe05d46a606ab3c.gif";